module.exports = __webpack_public_path__ + "img/219-isle-of-man.7fd93adb.svg";